import { render, staticRenderFns } from "./AppointmentConfigListItem.vue?vue&type=template&id=39e49bfc"
import script from "./AppointmentConfigListItem.vue?vue&type=script&lang=js"
export * from "./AppointmentConfigListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports